<template>
  <div class="success-home">
    <div class="big-title">跨国公司投资广东年会</div>
    <div class="success-body">
      <img :src="tipsIcon" />
      <div class="success-tip">提交成功</div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';

export default {
  components: {
    [Toast.name]: Toast,
  },

  data() {
    return {
      tipsIcon: require('@/assets/image/success.png'),
    };
  },
};
</script>
<style lang="less">
.success-home {
  background: url(/img/bg.1e0b7ab2.png);
  width: 100%;
  background-size: 100% 100%;

  .big-title {
    width: 100%;
    height: 56px;
    color: white;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 42px;
    padding-top: 17px;
  }
  .success-body {
    text-align: center;
    margin-top: 40%;
    padding: 3.53333rem 0.72rem;
    font-size: 0.4rem;
    position: relative;
    background-color: white;
    margin: 0.29333rem;
    box-shadow: 0 0.18667rem 0.42667rem 0 rgba(104, 112, 190, 0.34);
    border-radius: 0.26667rem;
    img {
      width: 96px;
      height: 96px;
    }
    .success-tip {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 42px;
    }
  }
}
</style>
